/** The sentence being built: a list of tokens (a symbol or a typed word). */
import type { PictoSource } from './picto';

export interface Token {
  key: string;
  text: string;
  picto?: PictoSource;
}

export type SentenceAction =
  | { type: 'add'; token: Token }
  | { type: 'addWords'; text: string }
  | { type: 'removeLast' }
  | { type: 'removeAt'; index: number }
  | { type: 'clear' };

let counter = 0;
const key = () => `t${++counter}`;

export function sentenceReducer(state: Token[], action: SentenceAction): Token[] {
  switch (action.type) {
    case 'add':
      return [...state, action.token];
    case 'addWords': {
      const words = action.text.split(/\s+/).filter(Boolean);
      return words.length ? [...state, ...words.map((text) => ({ key: key(), text }))] : state;
    }
    case 'removeLast':
      return state.slice(0, -1);
    case 'removeAt':
      return state.filter((_, i) => i !== action.index);
    case 'clear':
      return [];
  }
}

export function makeToken(text: string, picto?: PictoSource): Token {
  return { key: key(), text, picto };
}

export function sentenceText(tokens: Token[], draft = ''): string {
  return [...tokens.map((t) => t.text), draft.trim()].filter(Boolean).join(' ');
}
